@if (state.status === 'saving') {
  <oo-overlay-spinner></oo-overlay-spinner>
}
<oo-nav-back [url]="backUrl()"></oo-nav-back>
<oo-loading-container [status]="state.status">
  <ng-template>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>{{ state.form.name }}</mat-card-title>
        <mat-card-subtitle>Betting closes at: {{ state.form.startsAt | date:'dd/MM/yyyy HH:mm' }}
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content></mat-card-content>
    </mat-card>

    @switch (state.form.formType) {
      @case (formType.MATCH) {
        <oo-match-form-filler
          [bettingForm]="state.bettingForm"
          [betting]="state.form.userBetting || state.form.bettingResult"
          [config]="state.form.config!"
          [metadata]="$any(state.form.metadata)">
        </oo-match-form-filler>
      }
      @case (formType.GROUP_STAGE) {
        <oo-group-stage-form-filler
          [bettingForm]="state.bettingForm"
          [betting]="state.form.userBetting || state.form.bettingResult"
          [config]="state.form.config!"
          [isSubmissionMode]="state.isSubmissionMode"
          [metadata]="$any(state.form.metadata)">
        </oo-group-stage-form-filler>
      }
      @case (formType.TOURNAMENT_GENERAL) {
        <oo-tournament-general-form-filler
          [bettingForm]="state.bettingForm"
          [betting]="state.form.userBetting || state.form.bettingResult"
          [config]="state.form.config!"
          [isSubmissionMode]="state.isSubmissionMode"
          [metadata]="$any(state.form.metadata)">
        </oo-tournament-general-form-filler>
      }
      @case (formType.PLAYOFF_STAGE) {
        <oo-playoff-form-filler
          [bettingForm]="state.bettingForm"
          [betting]="state.form.userBetting || state.form.bettingResult"
          [config]="state.form.config!"
          [isSubmissionMode]="state.isSubmissionMode"
          [metadata]="$any(state.form.metadata)">
        </oo-playoff-form-filler>
      }
      @case (formType.CHAMPIONS_LEAGUE) {
        <oo-champions-league-stage
          [bettingForm]="state.bettingForm"
          [betting]="state.form.userBetting || state.form.bettingResult"
          [config]="state.form.config!"
          [isSubmissionMode]="state.isSubmissionMode"
          [metadata]="$any(state.form.metadata)">
        </oo-champions-league-stage>
      }
    }
    @if (state.bettingForm.enabled) {
      <button (click)="submit()"
              [disabled]="state.bettingForm.invalid || state.status === 'saving'"
              class="fo-submit-btn"
              color="primary"
              mat-raised-button>
        <span>Send</span>
        <mat-icon>send</mat-icon>
      </button>
    }
  </ng-template>
</oo-loading-container>
